// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__xFPF5","fileDisabled":"File_fileDisabled__2jL7D"};